import React from "react";
import { CategoryListScreenContextType } from "./types";

export const CategoryListScreenContext = React.createContext<
  CategoryListScreenContextType | undefined
>(undefined);
